import { render, staticRenderFns } from "./EditProducts.vue?vue&type=template&id=b5f2eaac&scoped=true"
import script from "./EditProducts.vue?vue&type=script&lang=js"
export * from "./EditProducts.vue?vue&type=script&lang=js"
import style0 from "./EditProducts.vue?vue&type=style&index=0&id=b5f2eaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f2eaac",
  null
  
)

export default component.exports